(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("angular"));
	else if(typeof define === 'function' && define.amd)
		define("IMRMXGraphAngularJS", ["angular"], factory);
	else if(typeof exports === 'object')
		exports["IMRMXGraphAngularJS"] = factory(require("angular"));
	else
		root["IMRMXGraphAngularJS"] = factory(root["angular"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_angular__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/index.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "../../Utils/index.ts":
/*!********************************************************************************!*\
  !*** C:/AIUT/TFS/Main/Presentation/Web/Common/Controls.MXGraph/Utils/index.ts ***!
  \********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var mx_graph_dictionary_adapter_1 = __webpack_require__(/*! ./mx-graph.dictionary.adapter */ "../../Utils/mx-graph.dictionary.adapter.ts");
exports.IMRMXGraphDictionaryAdapter = mx_graph_dictionary_adapter_1.IMRMXGraphDictionaryAdapter;


/***/ }),

/***/ "../../Utils/mx-graph.dictionary.adapter.ts":
/*!******************************************************************************************************!*\
  !*** C:/AIUT/TFS/Main/Presentation/Web/Common/Controls.MXGraph/Utils/mx-graph.dictionary.adapter.ts ***!
  \******************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* tslint:disable */
Object.defineProperty(exports, "__esModule", { value: true });
var IMRMXGraphDictionaryAdapter = /** @class */ (function () {
    function IMRMXGraphDictionaryAdapter() {
        this.floatRegex = /^-?\d+(?:[.,]\d*?)?$/;
        this.intRegex = /^-?\d+$/;
    }
    IMRMXGraphDictionaryAdapter.prototype.toMxGraphDictionaryStructure = function (arg, scripts, dataTypeDict) {
        this.dictionaryStruct = [];
        this.dataTypeDict = dataTypeDict;
        if (scripts == null) {
            var dataListStruct = [];
            var dataListDisplayStruct = [];
            if (arg !== undefined && arg != null) {
                var argDataList = this.retrieveDataList(arg);
                this.dictionaryStruct.push({ name: "dataList", dictionary: argDataList["dataStruct"] });
                this.dictionaryStruct.push({ name: "dataListDisplay", dictionary: argDataList["dataStructDisplay"] });
                var argDynamicValues = this.retrieveDynamicValues(arg);
                this.dictionaryStruct.push({ name: "dynamicValues", dictionary: argDynamicValues["dataStruct"] });
                this.dictionaryStruct.push({ name: "dynamicValuesDisplay", dictionary: argDynamicValues["dataStructDisplay"] });
                if ("currentDevices" in arg) {
                    var currentDevices = arg["currentDevices"];
                    for (var i = 0; i < currentDevices.length; i++) {
                        if (currentDevices[i] !== null) {
                            var deviceDictName = null;
                            var deviceDataStruct = [];
                            var deviceDataStructDisplay = [];
                            var deviceDynamicValues = [];
                            var deviceDataList = [];
                            if ("dynamicValues" in currentDevices[i]) {
                                var devDynamicValue = currentDevices[i]["dynamicValues"];
                                // @ts-ignore
                                var productCode = devDynamicValue.filter(function (dynamicValue) { return dynamicValue.Key == "MET1_2037_0"; });
                                if (productCode !== null && productCode.length > 0) {
                                    deviceDictName = productCode[0]["Value"].toString();
                                }
                                if (deviceDictName == null) {
                                    // @ts-ignore
                                    var serialNbr = devDynamicValue.filter(function (dynamicValue) { return dynamicValue.Key == "DEV1_10004_0"; });
                                    if (serialNbr !== null && serialNbr.length > 0) {
                                        deviceDictName = serialNbr[0]["Value"].toString();
                                    }
                                    // @ts-ignore
                                    if (deviceDictName == null && "serialNbr" in arg && arg["serialNbr"] !== null) {
                                        // @ts-ignore
                                        deviceDictName = arg["serialNbr"].toString();
                                    }
                                }
                                deviceDynamicValues = this.retrieveDynamicValues(currentDevices[i]);
                            }
                            if ("dataList" in currentDevices[i]) {
                                deviceDataList = this.retrieveDataList(currentDevices[i]);
                            }
                        }
                        deviceDataStruct = deviceDynamicValues["dataStruct"].concat(deviceDataList["dataStruct"]);
                        deviceDataStructDisplay = deviceDynamicValues["dataStructDisplay"].concat(deviceDataList["dataStructDisplay"]);
                        this.dictionaryStruct.push({ name: deviceDictName, dictionary: deviceDataStruct });
                        this.dictionaryStruct.push({ name: deviceDictName + "Display", dictionary: deviceDataStructDisplay });
                    }
                }
            }
        }
        else {
            try {
                // @ts-ignore
                if (scripts instanceof Array) {
                    for (var script in scripts) {
                        eval(scripts[script]);
                    }
                }
                // @ts-ignore
                else if (typeof scripts === 'string') {
                    eval(scripts);
                }
            }
            catch (error) {
            }
        }
        return this.dictionaryStruct;
    };
    IMRMXGraphDictionaryAdapter.prototype.retrieveDataList = function (obj) {
        var dataStruct = [];
        var dataStructDisplay = [];
        if ("dataList" in obj) {
            var dataList = (obj.dataList);
            if (dataList !== null) {
                dataList = dataList.toArray();
                for (var i = 0; i < dataList.length; i++) {
                    if (dataList[i] !== null && dataList[i].value !== null) {
                        var valType = this.trytoFindType(dataList[i].value);
                        if (dataList[i].dataType !== null && dataList[i].dataType !== undefined) {
                            var elementName = this.dataTypeDict.tryGetValue(dataList[i]["idDataType"]);
                            if (elementName == null) {
                                elementName = dataList[i].dataType.toString().trim();
                            }
                            else {
                                elementName = elementName["name"].trim();
                            }
                            dataStruct.push({ key: elementName, value: dataList[i].value, type: valType });
                            dataStructDisplay.push({ key: elementName, value: dataList[i].value.toString(), type: "string" });
                        }
                    }
                }
            }
        }
        return { "dataStruct": dataStruct, "dataStructDisplay": dataStructDisplay };
    };
    IMRMXGraphDictionaryAdapter.prototype.retrieveDynamicValues = function (obj) {
        var dataStruct = [];
        var dataStructDisplay = [];
        if ("dynamicValues" in obj) {
            var dynamicValues = obj["dynamicValues"];
            for (var i = 0; i < dynamicValues.length; i++) {
                if (dynamicValues[i] !== null && dynamicValues[i].Key !== null && dynamicValues[i].Value !== null) {
                    var valType = this.trytoFindType(dynamicValues[i].Value);
                    var idDataType = this.getIdDataType(dynamicValues[i].Key.toString().trim());
                    var elementName = this.dataTypeDict.tryGetValue(idDataType);
                    if (elementName == null) {
                        elementName = dynamicValues[i].Key.toString().trim();
                    }
                    else {
                        elementName = elementName["name"].trim();
                    }
                    dataStruct.push({ key: elementName, value: dynamicValues[i].Value, type: valType });
                    dataStructDisplay.push({ key: elementName, value: dynamicValues[i].Value.toString(), type: "string" });
                }
            }
        }
        return { "dataStruct": dataStruct, "dataStructDisplay": dataStructDisplay };
    };
    IMRMXGraphDictionaryAdapter.prototype.getIdDataType = function (name) {
        var retVal = -1;
        var splitName = name.split("_");
        if (splitName !== null && splitName.length > 2) {
            retVal = parseInt(splitName[1]);
        }
        return retVal;
    };
    IMRMXGraphDictionaryAdapter.prototype.trytoFindType = function (obj) {
        if (typeof (obj) == "string") {
            if (this.isDate(obj))
                return "date";
            else
                return "string";
        }
        else
            obj = obj.toString();
        if (this.isInt(obj))
            return "int";
        else if (this.isFloat(obj))
            return "float";
        else if (this.isBool(obj))
            return "bool";
        else
            return "string";
    };
    IMRMXGraphDictionaryAdapter.prototype.isDate = function (val) {
        var timestamp = Date.parse(val);
        if (isNaN(timestamp) == false) {
            return true;
            ;
        }
        return false;
    };
    IMRMXGraphDictionaryAdapter.prototype.isBool = function (val) {
        if (val == "true" || val == "false") {
            return true;
        }
        else {
            return false;
        }
    };
    IMRMXGraphDictionaryAdapter.prototype.isFloat = function (val) {
        if (!this.floatRegex.test(val))
            return false;
        val = parseFloat(val);
        if (isNaN(val))
            return false;
        return true;
    };
    IMRMXGraphDictionaryAdapter.prototype.isInt = function (val) {
        if (!this.intRegex.test(val))
            return false;
        var intVal = parseInt(val, 10);
        return parseFloat(val) == intVal && !isNaN(intVal);
    };
    return IMRMXGraphDictionaryAdapter;
}());
exports.IMRMXGraphDictionaryAdapter = IMRMXGraphDictionaryAdapter;


/***/ }),

/***/ "./node_modules/tslib/tslib.es6.js":
/*!*****************************************!*\
  !*** ./node_modules/tslib/tslib.es6.js ***!
  \*****************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault, __classPrivateFieldGet, __classPrivateFieldSet */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__classPrivateFieldGet", function() { return __classPrivateFieldGet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__classPrivateFieldSet", function() { return __classPrivateFieldSet; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),

/***/ "./src/index.ts":
/*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * AngularJS MX Graph controls module.
 *
 * @packageDocumentation
 * @module MXGraph
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
//#region Angular Imports
var angular_1 = tslib_1.__importDefault(__webpack_require__(/*! angular */ "angular"));
//#endregion
var mx_graph_directive_1 = __webpack_require__(/*! ./mx-graph/mx-graph.directive */ "./src/mx-graph/mx-graph.directive.ts");
exports.MODULE_NAME = 'imr.mxgraph';
angular_1.default
    .module(exports.MODULE_NAME, [])
    .directive(mx_graph_directive_1.DIRECTIVE_NAME, function () { return new mx_graph_directive_1.MXGraphDirective(); });
//#endregion


/***/ }),

/***/ "./src/mx-graph/mx-graph.directive.controller.ts":
/*!*******************************************************!*\
  !*** ./src/mx-graph/mx-graph.directive.controller.ts ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * AngularJS MX Graph directive controller.
 *
 * @packageDocumentation
 * @module MXGraph
 */
Object.defineProperty(exports, "__esModule", { value: true });
//#endregion
//#region MXGraph Imports
var _utils_1 = __webpack_require__(/*! @utils */ "../../Utils/index.ts");
var IMRMXGraphDirectiveController = /** @class */ (function () {
    //#endregion
    //#region Ctor
    function IMRMXGraphDirectiveController($scope, $element) {
        var graphIframe = document.getElementById('mxGraphFrame');
        var iframe;
        $scope.options.frameId = graphIframe.id =
            'mxGraphFrame' + Date.now().toString();
        var messageCallback = function (event) {
            console.log(IMRMXGraphDirectiveController.MX_GRAPH_LOG_PREFIX, 'Received MXGraph loaded message.');
            if (event.data === '1') {
                window.removeEventListener('message', messageCallback, false);
                iframe = document.getElementById($scope.options.frameId);
                iframe.setAttribute('data-isloaded', '1');
                if (iframe != null) {
                    setTimeout(function () {
                        var graphAd = new _utils_1.IMRMXGraphDictionaryAdapter();
                        var dictionaryStruct = graphAd.toMxGraphDictionaryStructure($scope.options.location, $scope.options.scripts, $scope.options.datatypeDict);
                        var graphSchema = $scope.options.schema;
                        console.log(IMRMXGraphDirectiveController.MX_GRAPH_LOG_PREFIX, 'Setting xml and visualizing.');
                        // @ts-ignore
                        iframe.contentWindow['setGraphXML'](graphSchema);
                        // @ts-ignore
                        iframe.contentWindow['visualize'](dictionaryStruct, $scope.options.visualizationOnly, $scope.options.language);
                    }, 100);
                }
            }
        };
        window.addEventListener('message', messageCallback, false);
        if ($scope.options.control !== undefined) {
            $scope.options.control = this.getSchemaXML;
        }
    }
    Object.defineProperty(IMRMXGraphDirectiveController, "MX_GRAPH_LOG_PREFIX", {
        //#region Consts
        get: function () {
            return '[IMR.MXGraph] - %s';
        },
        enumerable: true,
        configurable: true
    });
    //#endregion
    //#region IController Implementations
    IMRMXGraphDirectiveController.prototype.$onInit = function () {
        return;
    };
    //#endregion
    IMRMXGraphDirectiveController.prototype.getSchemaXML = function (graphOptions) {
        var schemaXML = null;
        if (graphOptions != null) {
            if (graphOptions.schemaModel != null &&
                graphOptions.schema != null) {
                if (graphOptions.frameId != null) {
                    var graphIframe = document.getElementById(graphOptions.frameId);
                    if (graphIframe !== undefined && graphIframe != null) {
                        var isLoaded = graphIframe.getAttribute('data-isloaded');
                        if (isLoaded === '1') {
                            var iframe = document.getElementById(graphOptions.frameId);
                            if (iframe != null && iframe.contentWindow != null) {
                                schemaXML = iframe.contentWindow[
                                // @ts-ignore
                                'getGraphXML']();
                            }
                        }
                    }
                }
            }
        }
        return schemaXML;
    };
    return IMRMXGraphDirectiveController;
}());
exports.IMRMXGraphDirectiveController = IMRMXGraphDirectiveController;


/***/ }),

/***/ "./src/mx-graph/mx-graph.directive.ts":
/*!********************************************!*\
  !*** ./src/mx-graph/mx-graph.directive.ts ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//#region Angular Imports
Object.defineProperty(exports, "__esModule", { value: true });
//#endregion
var mx_graph_directive_controller_1 = __webpack_require__(/*! ./mx-graph.directive.controller */ "./src/mx-graph/mx-graph.directive.controller.ts");
/**
 * AngularJS MX Graph directive.
 *
 * @packageDocumentation
 * @module MXGraph
 */
exports.DIRECTIVE_NAME = 'imrMxgraph';
var MXGraphDirective = /** @class */ (function () {
    function MXGraphDirective() {
        this.scope = {
            options: '='
        };
        this.controller = ['$scope', '$element', function ($scope, $element) { return new mx_graph_directive_controller_1.IMRMXGraphDirectiveController($scope, $element); }];
        this.template = '<iframe id="mxGraphFrame" name="mxGraphFrame" data-isloaded="0" src="./MXGraph/index.html" frameborder="0" style="display: block; width: 100%; height: 94%;"></iframe>';
    }
    return MXGraphDirective;
}());
exports.MXGraphDirective = MXGraphDirective;


/***/ }),

/***/ "angular":
/*!**************************!*\
  !*** external "angular" ***!
  \**************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_angular__;

/***/ })

/******/ });
});
//# sourceMappingURL=index.js.map